import React from 'react';
import classes from './ButtonBasic.module.css';

interface ButtonBasicProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  children: React.ReactNode;
  className?: string;
  ariaLabel?: string;
}

function ButtonBasic({
  children,
  className = '',
  ariaLabel = '',
  ...rest
}: ButtonBasicProps): React.ReactElement {
  return (
    <button
      className={`${classes.buttonBasic} ${className}`}
      aria-label={ariaLabel}
      type="button"
      {...rest}
    >
      {children}
    </button>
  );
}

export type { ButtonBasicProps };

export default ButtonBasic;
